<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Actualizare Info Document</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>
    <form [formGroup]="form">
        <br>
        <div class="row">
            <div class="col-md-10">
                <mat-form-field appearance="fill">
                    <mat-label>Cale de intrare</mat-label>
                    <mat-select formControlName="source" (selectionChange)="addSerie()">
                        <mat-option *ngFor="let optionSursa of surse" [value]="optionSursa.id">
                            {{ optionSursa.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['source'].valid && form.controls['source'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-2">
                <button type="button" class="btn btn-sm btn-primary btn-add-serie w-100" (click)="addSerie()">
                    <i class="fa-solid fa-plus"></i>
                    Adaugă cale
                </button>
            </div>
        </div>

        <div *ngIf="!sourceArr.length" class="mb-3">
            <mat-error>
                Adăugați minim o cale de intrare
            </mat-error>
        </div>

        <div *ngIf="sourceArr.length" class="mb-3">
            <mat-chip-listbox aria-label="Căi de intrare">
                <mat-chip *ngFor="let sursa of sourceArr; let i = index" (removed)="removeSerie(i)">
                    {{sursa.name}}
                    <button matChipRemove [attr.aria-label]="'remove ' + sursa.name">
                        <mat-icon class="serie-remove-icon">cancel</mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-listbox>
        </div>

        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Tip Document</mat-label>
                    <input matInput [formControl]="tipDocumenteControl" [matAutocomplete]="autoTipDocumente"
                        (blur)="onTipDocumenteBlur()" />
                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                    <mat-autocomplete #autoTipDocumente="matAutocomplete" [displayWith]="displayTipDocumente"
                        (optionSelected)="onTipDocumenteSelected($event.option.value)">
                        <mat-option *ngIf="showTipDocumenteMessage" disabled>
                            <span *ngIf="!tipDocumenteControl.value || tipDocumenteControl.value.length < 2">
                                Vă rugăm să introduceți 2 caractere sau mai multe
                            </span>
                            <span
                                *ngIf="isTipDocumenteLoading && tipDocumenteControl.value && tipDocumenteControl.value.length >= 2">Căutare...</span>
                            <span
                                *ngIf="!isTipDocumenteLoading && tipDocumenteLoadComplete && tipDocumente.length === 0 && tipDocumenteControl.value && tipDocumenteControl.value.length >= 2">
                                Nu au fost găsite rezultate
                            </span>
                        </mat-option>

                        <mat-option *ngFor="let doc of tipDocumente" [value]="doc">
                            {{ doc.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="!tipDocumenteControl.valid && tipDocumenteControl.touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Număr Document Părinte</mat-label>
                    <input matInput formControlName="parent_no" />
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-21">
                <mat-form-field appearance="fill">
                    <mat-label>An Document Părinte (ex: 2025)</mat-label>
                    <input matInput type="number" formControlName="parent_year" />
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Cuvinte cheie</mat-label>
                    <input matInput type="text" formControlName="keywords" />
                    <mat-error *ngIf="!form.controls['keywords'].valid && form.controls['keywords'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-21">
                <mat-form-field appearance="fill">
                    <mat-label>Număr Pagini</mat-label>
                    <input matInput type="number" formControlName="no_pages" />
                    <mat-error *ngIf="!form.controls['no_pages'].valid && form.controls['no_pages'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <h5 class="mb-3"><span class="text-danger">*</span> <i>Câmpuri obligatorii</i></h5>
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary"
                    [disabled]="sourceArr.length === 0 || form.invalid" (click)="submitForm()">
                    Actualizează
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-fixed" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>